import { IconWrapper } from '../runtime';
export default IconWrapper('kdlogo-line', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 7L1.75 4L8 1L14.25 4M8 7L14.25 4M8 7V15M14.25 4V12L8 15M8 11L1.75 8L5.96039 6.02099M8 15L1.75 12L5.951 10.0165",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});